import i18n from '../i18n';

export default {
  data() {
    return {
      rules: {
        required: value => !!value || i18n.t('validation.required'),
        requiredWith: (show, value) => (!show || !!value) || i18n.t('validation.required'),
        requiredNumber:
          (show, value) =>
            (
              !show
              || (value !== null && value.length && value >= 0)
            )
            || i18n.t('validation.required'),
        title: value => (value ? value.length < 100 : true) || i18n.t('snowGuarantee.validation.title.length'),
        visibility:
          (obj, value) =>
            (
              value
                ? (obj.title && obj.title.length > 0)
                && (obj.description && obj.description.length > 0)
                : true
            )
            || i18n.t('snowGuarantee.validation.visibility'),
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validatorMixin.js